<template>
  <b-container class="d-flex justify-content-center flex-column mb-5">
    <div class="row justify-content-center mt-2 mt-md-5">
      <div class="col-md-8">
        <div class="row justify-content-between mr-2 ml-2">
          <back-arrow :title="annonce.tostring"/>

          <div class="ml-auto d-flex align-items-center">
            <div v-if="!annonce.isMine"
                 class="small-primary-button bold-text mr-2"
                 @click="tryMatchWithAnnonce"
            >{{ $t('annonce.show.try.match') }}
            </div>
          </div>
          <div class="ml-3 d-flex align-items-center">
            <svg class="cursor-pointer" fill="none" height="30" viewBox="0 0 30 30" width="30"
                 xmlns="http://www.w3.org/2000/svg" @click="openSocialMediaModal">
              <path d="M26.25 12.1875L20.625 17.8125V6.5625L26.25 12.1875Z" fill="#EAEAEA" opacity="0.2"/>
              <path
                d="M26.9133 11.524L21.2883 5.89898C21.1572 5.76772 20.9901 5.67831 20.8081 5.64208C20.6261 5.60584 20.4375 5.62441 20.2661 5.69543C20.0947 5.76645 19.9483 5.88672 19.8453 6.04103C19.7423 6.19534 19.6874 6.37673 19.6875 6.56226V11.2498H19.3359C16.6327 11.2472 14.0053 12.144 11.8678 13.7988C9.73024 15.4537 8.20394 17.7726 7.5293 20.3904C7.46714 20.6313 7.50321 20.887 7.62957 21.1012C7.75594 21.3155 7.96225 21.4708 8.20312 21.533C8.444 21.5951 8.69969 21.5591 8.91397 21.4327C9.12824 21.3063 9.28354 21.1 9.3457 20.8591C9.91748 18.6446 11.2092 16.683 13.0177 15.2829C14.8262 13.8828 17.0488 13.1236 19.3359 13.1248H19.6875V17.8123C19.6874 17.9978 19.7423 18.1792 19.8453 18.3335C19.9483 18.4878 20.0947 18.6081 20.2661 18.6791C20.4375 18.7501 20.6261 18.7687 20.8081 18.7324C20.9901 18.6962 21.1572 18.6068 21.2883 18.4755L26.9133 12.8505C27.0004 12.7635 27.0696 12.6601 27.1168 12.5463C27.164 12.4325 27.1882 12.3105 27.1882 12.1873C27.1882 12.0641 27.164 11.9421 27.1168 11.8283C27.0696 11.7144 27.0004 11.611 26.9133 11.524ZM21.5625 15.5494V8.82515L24.9246 12.1873L21.5625 15.5494ZM23.4375 25.3123C23.4375 25.5609 23.3387 25.7994 23.1629 25.9752C22.9871 26.151 22.7486 26.2498 22.5 26.2498H4.6875C4.19022 26.2498 3.71331 26.0522 3.36167 25.7006C3.01004 25.349 2.8125 24.872 2.8125 24.3748V10.3123C2.8125 10.0636 2.91127 9.82516 3.08709 9.64935C3.2629 9.47353 3.50136 9.37476 3.75 9.37476C3.99864 9.37476 4.2371 9.47353 4.41291 9.64935C4.58873 9.82516 4.6875 10.0636 4.6875 10.3123V24.3748H22.5C22.7486 24.3748 22.9871 24.4735 23.1629 24.6493C23.3387 24.8252 23.4375 25.0636 23.4375 25.3123Z"
                fill="#EAEAEA"/>
            </svg>
          </div>
          <div v-if="!annonce.isMine" class="d-flex align-items-center">
            <svg v-if="!annonce.annonceFavorite" class="cursor-pointer ml-3"
                 fill="none" height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg"
                 @click="updateFavorite(annonce.annonceFavorite)">
              <path
                d="M27.1875 11.0156C27.1875 18.75 15 25.3125 15 25.3125C15 25.3125 2.8125 18.75 2.8125 11.0156C2.8125 9.3373 3.47921 7.72772 4.66596 6.54096C5.85272 5.35421 7.4623 4.6875 9.14062 4.6875C11.7879 4.6875 14.0555 6.13008 15 8.4375C15.9445 6.13008 18.2121 4.6875 20.8594 4.6875C22.5377 4.6875 24.1473 5.35421 25.334 6.54096C26.5208 7.72772 27.1875 9.3373 27.1875 11.0156Z"
                fill="#EAEAEA"
                opacity="0.2"/>
              <path
                d="M20.8594 3.75C18.4395 3.75 16.3207 4.79062 15 6.54961C13.6793 4.79062 11.5605 3.75 9.14062 3.75C7.21433 3.75217 5.36755 4.51835 4.00545 5.88045C2.64335 7.24255 1.87717 9.08933 1.875 11.0156C1.875 19.2187 14.0379 25.8586 14.5559 26.1328C14.6924 26.2063 14.845 26.2447 15 26.2447C15.155 26.2447 15.3076 26.2063 15.4441 26.1328C15.9621 25.8586 28.125 19.2187 28.125 11.0156C28.1228 9.08933 27.3566 7.24255 25.9946 5.88045C24.6325 4.51835 22.7857 3.75217 20.8594 3.75ZM15 24.2344C12.8602 22.9875 3.75 17.3074 3.75 11.0156C3.75186 9.58651 4.3204 8.21647 5.33093 7.20593C6.34147 6.1954 7.71151 5.62686 9.14062 5.625C11.4199 5.625 13.3336 6.83906 14.1328 8.78906C14.2034 8.96101 14.3236 9.10808 14.478 9.21158C14.6324 9.31508 14.8141 9.37034 15 9.37034C15.1859 9.37034 15.3676 9.31508 15.522 9.21158C15.6764 9.10808 15.7966 8.96101 15.8672 8.78906C16.6664 6.83555 18.5801 5.625 20.8594 5.625C22.2885 5.62686 23.6585 6.1954 24.6691 7.20593C25.6796 8.21647 26.2481 9.58651 26.25 11.0156C26.25 17.298 17.1375 22.9863 15 24.2344Z"
                fill="#EAEAEA"/>
            </svg>
            <svg v-else class="cursor-pointer ml-3" fill="none" height="30"
                 viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg"
                 @click="updateFavorite(annonce.annonceFavorite)">
              <path
                d="M27.1875 11.0156C27.1875 18.75 15 25.3125 15 25.3125C15 25.3125 2.8125 18.75 2.8125 11.0156C2.8125 9.3373 3.47921 7.72772 4.66596 6.54096C5.85272 5.35421 7.4623 4.6875 9.14062 4.6875C11.7879 4.6875 14.0555 6.13008 15 8.4375C15.9445 6.13008 18.2121 4.6875 20.8594 4.6875C22.5377 4.6875 24.1473 5.35421 25.334 6.54096C26.5208 7.72772 27.1875 9.3373 27.1875 11.0156Z"
                fill="#E74A49"
                opacity="1"/>
              <path
                d="M20.8594 3.75C18.4395 3.75 16.3207 4.79062 15 6.54961C13.6793 4.79062 11.5605 3.75 9.14062 3.75C7.21433 3.75217 5.36755 4.51835 4.00545 5.88045C2.64335 7.24255 1.87717 9.08933 1.875 11.0156C1.875 19.2187 14.0379 25.8586 14.5559 26.1328C14.6924 26.2063 14.845 26.2447 15 26.2447C15.155 26.2447 15.3076 26.2063 15.4441 26.1328C15.9621 25.8586 28.125 19.2187 28.125 11.0156C28.1228 9.08933 27.3566 7.24255 25.9946 5.88045C24.6325 4.51835 22.7857 3.75217 20.8594 3.75ZM15 24.2344C12.8602 22.9875 3.75 17.3074 3.75 11.0156C3.75186 9.58651 4.3204 8.21647 5.33093 7.20593C6.34147 6.1954 7.71151 5.62686 9.14062 5.625C11.4199 5.625 13.3336 6.83906 14.1328 8.78906C14.2034 8.96101 14.3236 9.10808 14.478 9.21158C14.6324 9.31508 14.8141 9.37034 15 9.37034C15.1859 9.37034 15.3676 9.31508 15.522 9.21158C15.6764 9.10808 15.7966 8.96101 15.8672 8.78906C16.6664 6.83555 18.5801 5.625 20.8594 5.625C22.2885 5.62686 23.6585 6.1954 24.6691 7.20593C25.6796 8.21647 26.2481 9.58651 26.25 11.0156C26.25 17.298 17.1375 22.9863 15 24.2344Z"
                fill="#E74A49"/>
            </svg>
          </div>
          <div v-if="annonce.isMine"
               class="ml-2 d-flex align-items-center">
            <div v-if="!annonce.askedToBeDeleted" class="ph-custom ph-trash cursor-pointer"
                 style="font-size: 27px;color: var(--main-red-medium)"
                 @click="openDeleteModal"></div>
            <div v-else class="ph-custom ph-trash cursor-pointer"
                 style="font-size: 27px;color: var(--main-red-light)"
                 @click="openDeleteModalInProgress"></div>
          </div>
          <div v-if="annonce.isMine && annonce.status.value !=='VALIDATED' && !annonce.askedToBeDeleted"
               class=" ml-3 d-flex align-items-center">
            <svg class="cursor-pointer" fill="none" height="25" viewBox="0 0 25 25" width="25"
                 xmlns="http://www.w3.org/2000/svg"
                 @click="editAnnonce">
              <path
                d="M23.6379 6.59805L18.402 1.36094C18.2278 1.18679 18.0211 1.04864 17.7936 0.954382C17.5661 0.860127 17.3223 0.811615 17.076 0.811615C16.8297 0.811615 16.5859 0.860127 16.3584 0.954382C16.1308 1.04864 15.9241 1.18679 15.75 1.36094L1.29962 15.8125C1.12475 15.986 0.986111 16.1925 0.891758 16.42C0.797406 16.6476 0.749223 16.8916 0.750009 17.1379V22.375C0.750009 22.8723 0.947554 23.3492 1.29918 23.7008C1.65081 24.0525 2.12773 24.25 2.62501 24.25H7.86212C8.10844 24.2508 8.35246 24.2026 8.57999 24.1083C8.80752 24.0139 9.01403 23.8753 9.18751 23.7004L23.6379 9.25C23.8121 9.07589 23.9502 8.86917 24.0445 8.64166C24.1387 8.41414 24.1872 8.17029 24.1872 7.92403C24.1872 7.67776 24.1387 7.43391 24.0445 7.2064C23.9502 6.97888 23.8121 6.77217 23.6379 6.59805ZM3.0129 16.75L12.9375 6.82539L14.8934 8.78125L4.96876 18.7047L3.0129 16.75ZM2.62501 19.0129L5.98712 22.375H2.62501V19.0129ZM8.25001 21.9871L6.29415 20.0313L16.2188 10.1066L18.1746 12.0625L8.25001 21.9871ZM19.5 10.7371L14.2629 5.5L17.0754 2.6875L22.3125 7.92344L19.5 10.7371Z"
                fill="#FFED00"/>
            </svg>
          </div>
          <div v-if="annonce.isMine && annonce.status.value ==='VALIDATED'" class="ml-3 d-flex align-items-center">
            <div
              v-if="!AnnonceUtils.isBoostStillValid(annonce.boostEndDate)"
              class="small-primary-button small-tertiary-button bold-text mr-2"
              @click="navigateToBoostAnnonce"
            >{{ $t('annonce.show.boost.button') }}
            </div>
            <div
              class="small-primary-button bold-text mr-2"
              @click="navigateToAdditionnalReward"
            >{{ $t('annonce.show.additional.reward.button') }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center mt-2">
      <div class="col-md-8">
        <div v-if="annonce.isMine && annonce.status && annonce.status.value==='REFUSED'"
             class="row mr-2 ml-2 alert-danger rounded d-flex  p-1">
          <i class="ph-custom ph-x-circle main-red-color align-items-center ml-2"/>
          <span class="refused ml-3 main-red-color cursor-pointer" @click="showReasonRefused">
            {{ $t('annonce.refused.draft.content', {content: "voir les raisons"}) }}
          </span>
        </div>
        <div v-if="annonce.isMine && annonce.status && annonce.status.value==='TO_VALIDATE'"
             class="row mr-2 ml-2 alert-danger rounded d-flex  p-1">
          <i class="ph-custom ph-hourglass-high orange align-items-center"/>
          <span class="refused ml-2 orange">
            {{ $t('annonce.my.ongoing.validation.annonce') }}
          </span>
        </div>
        <div class="row mr-2 ml-2">
          <div v-for="(img, index) in visibleImages" :key="img.id" class="col-md-4 col-6 img-container">
            <b-img :src="getFileUrl(img.fileUrl)" alt="Image" class="img-vehicle cursor-pointer"
                   @click="toggler = !toggler"></b-img>
            <div v-if="index === 2 && moreImagesCount" class="overlay cursor-pointer" @click="toggler = !toggler">
              +{{ moreImagesCount }}
            </div>
          </div>
          <FsLightbox
            :sources="this.sourceImg"
            :toggler="toggler"
            type="image"/>
        </div>

      </div>
    </div>

    <div class="row justify-content-center mt-2">
      <div class="col-md-8">
        <div class="row justify-start mr-2 ml-2">
          <div class="d-flex align-items-center">
            <i class="ph-custom ph-clock-counter-clockwise main-color" style="font-size: 22px"/>
            <span class="label-title ml-2">{{ convertTimestampToRelativeDate(annonce.date) }}</span>
          </div>
          <div v-if="annonce.nbViews > 122" class="d-flex align-items -center ml-auto">
            <i class="ph-custom ph-eye main-color" style="font-size: 22px"/>
            <span class="label-title ml-2">{{ nbViewsToStr(annonce.nbViews) }}</span>
          </div>
          <div v-else class="d-flex align-items -center ml-auto">
            <i class="ph-custom ph-eye main-color" style="font-size: 22px"/>
            <span class="label-title ml-2">{{ $t('new.annonce') }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center mt-2 d-md-none ">
      <div class="col-11 custom-separator">
      </div>
    </div>

    <div class="row justify-content-center mt-4">
      <div class="col-md-6">
        <h1 class="page-title">{{ $t('annonce.Information') }}</h1>
        <b-card class="mt-2  shadow-sm">
          <div class="row">
            <b-container fluid>
              <b-row>
                <div class="col-6 col-md-6 col-lg-6 mb-4">
                  <div class="d-flex align-items-center">
                    <i class="ph-custom ph-bold ph-wrench main-color"/>
                    <span class="label-detail-annonce">{{ $t('annonce.vehicle.vehicleType') }}</span>
                  </div>
                  <div>
                    {{
                      annonce.vehicle && annonce.vehicle.vehicleType && annonce.vehicle.vehicleType.name ? annonce.vehicle.vehicleType.name : $t("annonce.show.undefined")
                    }}
                  </div>
                </div>

                <div class="col-6 col-md-6 col-lg-6 mb-4">
                  <div class="d-flex align-items-center">
                    <i class="ph-custom ph-bold ph-wrench main-color"/>
                    <span class="label-detail-annonce">{{ $t('annonce.vehicle.Brand') }}</span>
                  </div>
                  <div>
                    {{
                      annonce.vehicle && annonce.vehicle.brand ? annonce.vehicle.brand : $t("annonce.show.undefined")
                    }}
                  </div>
                </div>


                <div class="col-6 col-md-6 col-lg-6 mb-4">
                  <div class="d-flex align-items-center">
                    <i class="ph-custom ph-bold ph-package main-color"/>
                    <span class="label-detail-annonce">{{ $t('annonce.vehicle.Model') }}</span>
                  </div>
                  <div>
                    {{
                      annonce.vehicle && annonce.vehicle.model ? annonce.vehicle.model : $t("annonce.show.undefined")
                    }}
                  </div>
                </div>

                <div class="col-6 col-md-6 col-lg-6 mb-4">
                  <div class="d-flex align-items-center">
                    <i class="ph-custom ph-bold ph-paint-brush main-color"/>
                    <span class="label-detail-annonce">{{ $t('annonce.vehicle.Finitions') }}</span>
                  </div>
                  <div>
                    {{
                      annonce.vehicle && annonce.vehicle.modelFinish ? annonce.vehicle.modelFinish : $t("annonce.show.undefined")
                    }}
                  </div>
                </div>

                <div class="col-6 col-md-6 col-lg-6 mb-4">
                  <div class="d-flex align-items-center">
                    <i class="ph-custom ph-bold ph-fire main-color"/>
                    <span class="label-detail-annonce">{{ $t('annonce.vehicle.Energy') }}</span>
                  </div>
                  <div>
                    {{
                      annonce.vehicle && annonce.vehicle.energy ? $t(annonce.vehicle.energy.text) : $t("annonce.show.undefined")
                    }}
                  </div>
                </div>

                <div class="col-6 col-md-6 col-lg-6 mb-4">
                  <div class="d-flex align-items-center">
                    <i class="ph-custom ph-bold ph-palette main-color"/>
                    <span class="label-detail-annonce">{{ $t('annonce.vehicle.Color') }}</span>
                  </div>
                  <div>
                    {{
                      annonce.vehicle && annonce.vehicle.color ? $t(annonce.vehicle.color.text) : $t("annonce.show.undefined")
                    }}
                  </div>
                </div>

                <div class="col-6 col-md-6 col-lg-6 mb-4">
                  <div class="d-flex align-items-center">
                    <i class="ph-custom ph-bold ph-gauge main-color"/>
                    <span class="label-detail-annonce">{{ $t('annonce.vehicle.engine.Power') }}</span>
                  </div>
                  <div>
                    {{
                      annonce.vehicle && annonce.vehicle.power ? annonce.vehicle.power : $t("annonce.show.undefined")
                    }}
                  </div>
                </div>

                <div class="col-12 col-md-6 col-lg-6 mb-4">
                  <div class="d-flex align-items-center">
                    <i class="ph-custom ph-bold ph-list main-color"/>
                    <span class="label-detail-annonce">{{ $t('annonce.details') }}</span>
                  </div>
                  <div>
                    {{ annonce.vehicle.description ? annonce.vehicle.description : $t("annonce.show.undefined") }}
                  </div>
                </div>

                <div v-if="annonce.vehicle" class="col-12 col-md-6 col-lg-6 mb-4">
                  <div class="d-flex align-items-center justify-content-center">
                    <span>{{ $t(titleIdentifiantVehicle.title) }}</span>
                  </div>
                  <div>
                    <div class="card-plate">
                      {{ titleIdentifiantVehicle.value.substring(0, titleIdentifiantVehicle.value.length - 2) }}**
                    </div>
                  </div>
                </div>

              </b-row>
            </b-container>
          </div>
        </b-card>
      </div>

      <div class="col-11 custom-separator mb-4 d-md-none">
      </div>

      <div class="col-md-2 ">
        <h1 v-if="center.lat" class="page-title map-title">{{ $t('annonce.last.positions') }}</h1>
        <gmap-map v-if="center.lat" :center="center" :options="gmapOptions" :zoom="14" class="gmap b122-gmap mt-2">
          <template v-for="(m, index) in locationMarkers">
            <gmap-marker
              :key="index"
              :clickable="m.clickable"
              :icon="getIcon(m.type)"
              :position="m.position"
              :z-index="m.zIndex"
              @click="openMarker(m)">
              <gmap-info-window
                v-if="m.clickable"
                :closeclick="true"
                :opened="openedMarkerID === m.id"
                :options="gmapInfoOptions"
                @closeclick="openMarker(null)">
                <div class="b122-gmap-info-window">
                  <div class="b122-gmap-info-window-title pb-2">
                    {{
                      $t('Position') + " " + new Date(m.date).toLocaleDateString('fr-FR', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit'
                      }) + " :"
                    }}
                  </div>
                  <div class="pb-1">
                    {{ $t('Lat') }}: {{ m.position.lat }}
                  </div>
                  <div class="pb-3">
                    {{ $t('Lng') }}: {{ m.position.lng }}
                  </div>
                  <div class="pb-1">
                    {{ $t('Address') }}: {{ address || 'Chargement...' }}
                  </div>
                </div>
              </gmap-info-window>
            </gmap-marker>

            <!-- zone pour THEFT_LOCATION -->
            <GmapCircle
              v-if="m.type === 'THEFT_LOCATION'"
              :key="index+'theftZone'"
              :center="m.position"
              :options="{fillColor:'#E74A49',fillOpacity:0.3, strokeOpacity:0, clickable: false}"
              :radius="1000"
              :visible="true"
            ></GmapCircle>
          </template>
        </gmap-map>
      </div>
    </div>

    <share-social-media-modal :id="annonce.id" :vehicle="annonce.vehicle"></share-social-media-modal>
    <annonce-reason-refused-modal v-if="annonce.isMine && annonce.reasonRefused"
                                  :reason="annonce.reasonRefused"></annonce-reason-refused-modal>

    <annonce-delete-modal :selected-item="annonce.id" :selected-item-name="annonce.tostring" begins-with-voyel
                          item-to-string="annonce"
                          the-article="l'"></annonce-delete-modal>
    <annonce-delete-modal-in-progress></annonce-delete-modal-in-progress>

  </b-container>


</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import ShareSocialMediaModal from './ShareSocialMediaModal'
import FsLightbox from "fslightbox-vue/v2"
import AnnonceReasonRefusedModal from "./AnnonceReasonRefusedModal"
import AnnonceUtils from "../../utils/AnnonceUtils"
import AnnonceDeleteModal from "./AnnonceCreate/AnnonceDeleteModal";
import AnnonceDeleteModalInProgress from "./AnnonceCreate/AnnonceDeleteModalInProgress";

export default {

  name: 'AnnonceShow',

  components: {
    AnnonceDeleteModal,
    BackArrow,
    ShareSocialMediaModal,
    FsLightbox,
    AnnonceReasonRefusedModal,
    AnnonceDeleteModalInProgress

  },

  data() {
    return {
      AnnonceUtils: AnnonceUtils,

      annonceId: this.$route.params.annonceId,
      annonce: {},
      isLoading: true,
      center: {
        lat: null,
        lng: null
      },
      gmapInfoOptions: {
        pixelOffset: {
          width: 0,
          height: -5
        }
      },
      openedMarkerID: null,
      locationMarkers: [],
      address: null,
      iconMapping: {
        THEFT_LOCATION: require(`@/assets/images/b122/ic-vol.png`),
        CONFIRMED_POSITION: require(`@/assets/images/b122/ic-position.png`),
        TRACKER: require(`@/assets/images/b122/ic-tracker.png`),
      },
      gmapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
      },
      visibleImages: [],
      moreImagesCount: 0,
      toggler: false,
      sourceImg: [],
    }
  },

  mounted() {
    this.fetchData()
  },

  computed: {
    titleIdentifiantVehicle() {
      if (this.annonce.vehicle) {
        if (this.annonce.vehicle.licensePlate) {
          return {
            title: this.$t('scan.menu.modal.scan.plate'),
            value: this.annonce.vehicle.licensePlate
          }
        } else if (this.annonce.vehicle.vin) {
          return {
            title: this.$t('scan.menu.modal.scan.vin'),
            value: this.annonce.vehicle.vin
          }
        } else if (this.annonce.vehicle.bicycode) {
          return {
            title: this.$t('scan.menu.modal.scan.bicycode'),
            value: this.annonce.vehicle.bicycode
          }
        } else if (this.annonce.vehicle.serialNumber) {
          return {
            title: this.$t('scan.menu.modal.scan.serial'),
            value: this.annonce.vehicle.serialNumber
          }
        }
      }
    }
  },

  watch: {
    'annonceId': function () {
      this.fetchAnnonce()
    }
  },

  methods: {
    fetchData() {
      this.fetchAnnonce()
    },

    getFileUrl(path) {
      return (window.location.hostname === "integration-grand-public-lamp.bleu122.com" ? "https://integration-lamp.bleu122.com" : process.env.SERVER_URL) + path
    },

    fetchAnnonce() {
      api
        .get(`/annonce/${this.annonceId}`)
        .then(response => {
          this.annonce = response.data
          if (this.annonce.isDeleted) {
            this.$router.go(-1)
          }
        })
        .then(() => {
          this.isLoading = false
          this.initLastPositions()
          this.prepareVisibleImages()
        })
        .catch((error) => {

        })
    },

    showReasonRefused() {
      this.$bvModal.show('reason-refused-annonce')
    },


    convertTimestampToRelativeDate(timestamp) {
      const currentTimestamp = Date.now();
      const diffInMs = currentTimestamp - timestamp;

      const secondsInMs = 1000;
      const minutesInMs = secondsInMs * 60;
      const hoursInMs = minutesInMs * 60;
      const daysInMs = hoursInMs * 24;
      const monthsInMs = daysInMs * 30; // Environ 30 jours par mois
      const yearsInMs = daysInMs * 365; // Environ 365 jours par an

      if (diffInMs < secondsInMs) {
        return "à l'instant";
      } else if (diffInMs < minutesInMs) {
        const secondsAgo = Math.floor(diffInMs / secondsInMs);
        return `il y a ${secondsAgo} ${secondsAgo === 1 ? 'seconde' : 'secondes'}`;
      } else if (diffInMs < hoursInMs) {
        const minutesAgo = Math.floor(diffInMs / minutesInMs);
        return `il y a ${minutesAgo} ${minutesAgo === 1 ? 'minute' : 'minutes'}`;
      } else if (diffInMs < daysInMs) {
        const hoursAgo = Math.floor(diffInMs / hoursInMs);
        return `il y a ${hoursAgo} ${hoursAgo === 1 ? 'heure' : 'heures'}`;
      } else if (diffInMs < monthsInMs) {
        const daysAgo = Math.floor(diffInMs / daysInMs);
        return `il y a ${daysAgo} ${daysAgo === 1 ? 'jour' : 'jours'}`;
      } else if (diffInMs < yearsInMs) {
        const monthsAgo = Math.floor(diffInMs / monthsInMs);
        return `il y a ${monthsAgo} ${monthsAgo === 1 ? 'mois' : 'mois'}`;
      } else {
        const yearsAgo = Math.floor(diffInMs / yearsInMs);
        return `il y a ${yearsAgo} ${yearsAgo === 1 ? 'an' : 'ans'}`;
      }
    },

    nbViewsToStr(views) {
      if (views <= 1) {
        return `${views} vue`
      } else {
        return `${views} vues`
      }
    },

    initLastPositions() {
      if (this.annonce.vehicle.theftPosition) {
        var item = this.annonce.vehicle.theftPosition
        let zIndex = item.type !== 'POLICE' ? 10 : 0
        const theftPosition = {
          clickable: false,
          position: {
            lat: item.latitude,
            lng: item.longitude
          },
          type: item.type,
          id: item.id,
          zIndex: zIndex
        }
        this.locationMarkers = [theftPosition]
        this.center = theftPosition.position

        //lastConfirmedPositionForInvalidMatch
        if (this.annonce.vehicle.positions.lastConfirmedPositionForInvalidMatch) {
          item = this.annonce.vehicle.positions.lastConfirmedPositionForInvalidMatch
          let zIndex = item.type !== 'POLICE' ? 10 : 0
          const lastConfirmedPositionForInvalidMatch = {
            clickable: true,
            position: {
              lat: item.latitude,
              lng: item.longitude
            },
            type: item.type,
            id: item.id,
            date: item.date,
            address: item.address,
            zIndex: zIndex
          }
          this.locationMarkers.push(lastConfirmedPositionForInvalidMatch)
          this.center = lastConfirmedPositionForInvalidMatch.position
        }

        //lastTrackerPosition
        if (this.annonce.vehicle.positions.lastTrackerPosition) {
          item = this.annonce.vehicle.positions.lastTrackerPosition
          let zIndex = item.type !== 'POLICE' ? 10 : 0
          const lastTrackerPosition = {
            clickable: true,
            position: {
              lat: item.latitude,
              lng: item.longitude
            },
            type: item.type,
            id: item.id,
            date: item.date,
            address: item.address,
            zIndex: zIndex
          }
          this.locationMarkers.push(lastTrackerPosition)
          this.center = lastTrackerPosition.position
        }
      }

    },
    getIcon(name) {
      const iconUrl = this.iconMapping[name];
      //anchor permet de centrer l'icone sur le point exact lat/lng - on prend pas exactement 30/2 = 15 car l'image utilisée n'est pas centrée (il y a une ombre)(sur une image de 120*120px le centre est à 56*56px)
      return iconUrl ? {
        url: iconUrl,
        size: {width: 30, height: 30, f: 'px', b: 'px'},
        anchor: {x: 14, y: 14},
        scaledSize: {width: 30, height: 30, f: 'px', b: 'px'}
      } : null;
    },
    openMarker(marker) {
      if (marker) {
        this.address = null;
        this.openedMarkerID = marker.id;
        if (marker.address) {
          this.address = marker.address;
        } else {
          this.getAddressFromCoords(marker.position.lat, marker.position.lng);
        }

      } else {
        this.openedMarkerID = null;
      }
    },
    getAddressFromCoords(lat, lng) {
      if (typeof google === 'undefined') {
        console.log("Google Maps API is not loaded yet.");
        return;
      }
      const geocoder = new google.maps.Geocoder();
      const latLng = new google.maps.LatLng(lat, lng);

      geocoder.geocode({'latLng': latLng}, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            this.address = results[0].formatted_address;
          } else {
            this.address = 'Aucun résultat trouvé';
          }
        } else {
          this.address = 'Erreur de géocodage : ' + status;
        }
      });
    },

    prepareVisibleImages() {
      this.visibleImages = this.annonce.vehicle.vehicleImages.slice(0, 3);
      this.moreImagesCount = this.annonce.vehicle.vehicleImages.length - this.visibleImages.length;
      this.sourceImg = this.annonce.vehicle.vehicleImages.map(file => this.getFileUrl(file.fileUrl));
    },

    updateFavorite(isFavoris) {
      const data = new FormData()
      data.append('annonceId', this.annonceId)
      api({
        method: 'POST',
        url: `/annonce/updateFavoris`,
        data: data
      })
        .then(() => {
          this.annonce.annonceFavorite = !isFavoris
        })
    },

    openSocialMediaModal() {
      this.$bvModal.show('share-social-media-modal')
    },

    tryMatchWithAnnonce() {
      this.$store.state.lastAnnonceMatchAttemptId = this.annonceId
      this.$nextTick(() => {
        this.$bvModal.show('scan-menu-modal')
      })
    },

    editAnnonce() {
      this.$router.push({
        name: 'AnnonceEdit',
        params: {
          annonceId: this.annonce.id
        }
      })
    },
    openDeleteModal() {
      this.$bvModal.show('annonce-delete-modal')
    },

    openDeleteModalInProgress() {
      this.$bvModal.show('annonce-delete-modal-in-progress')
    },


    navigateToAdditionnalReward() {
      this.$router.push({
        name: 'AnnonceAdditionnalRewardEdit',
        params: {
          annonceId: this.annonce.id
        }
      })
    },

    navigateToBoostAnnonce() {
      this.$router.push({
        name: 'AnnonceBoostEdit',
        params: {
          annonceId: this.annonce.id
        }
      })
    },
  }
}
</script>

<style scoped>
.documents-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  grid-gap: 0.5rem;
}

.document:nth-child(1) {
  grid-column: span 2;
  grid-row: span 2;
}


.document-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

.label-title {
  color: var(--main-grey-medium);
}

.label-detail-annonce {
  color: var(--main-grey-medium);
  font-size: 12px;
  margin-left: 0.25rem;
}

.ph-custom {
  font-size: 14px;
}

.vue-map {
  border-radius: var(--main-border-radius) !important;
}


.b122-gmap {
  flex-grow: 1;
  border-radius: var(--main-border-radius);
  height: 92%;
  min-height: 220px;
}

.map-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-card-img {
  height: 170px;
  border-radius: 10px;
}

.custom-card-img > img {
  object-fit: cover;
  border-radius: 10px;
  height: 100%;
  width: 100%;
}


.img-container {
  padding: 5px;
}

.img-vehicle {
  border-radius: var(--main-border-radius);
  width: 100%;
  height: 172px;
  object-fit: cover;
}

.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 1rem;
  border-radius: var(--main-border-radius);
  font-family: Agbalumo-Regular, "Arial", sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 22px;

}

@media (max-width: 768px) {

  .card {
    background-color: var(--main-black-darker);
  }

  .card-body {
    padding: 0 !important;
  }

  .img-container {
    padding-bottom: 5px;
  }

  .custom-separator {
    border: 1px solid var(--main-grey-dark);
    margin-top: 1rem;
  }

  .img-vehicle-0 {
    border-radius: var(--main-border-radius);
    width: 50%;
    height: 200px;
    object-fit: cover;
  }

  .img-vehicle-1 {
    border-radius: var(--main-border-radius);
    width: 25%;
    height: 100px;
    object-fit: cover;
  }

  .img-vehicle-2 {
    border-radius: var(--main-border-radius);
    width: 25%;
    height: 100px;
    object-fit: cover;
  }
}


.orange {
  color: var(--main-yellow-darker)
}


</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceShow.vue